<template>
  <table class="table table-striped table-bordered table-sortable" :class="{'table-fixed':fixed}">
    <thead>
        <tr>
            <th
              v-for="column in columns"
              :key="column.name"
              @click="column.disableOrder ? '' : $emit('sort', column.name)"
              :class="column.disableOrder ? '' : (sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sortable asc': 'sortable desc') : 'sortable')"
              :style="`width: ${column.width};`"
            >
                {{column.label}}
            </th>
        </tr>
        <tr class="text-center" v-if="loading">
          <th :colspan="columns.length">
            <loader-wave/>
          </th>
        </tr>
    </thead>
    <slot v-if="!loading"></slot>
  </table>
</template>

<script>
export default {
  props: ['columns', 'sortKey', 'sortOrders', 'loading', 'fixed'],
};
</script>
